<!-- Struct 分组 类型: g -->
<!-- 只包含普通结构 和 口径结构 -->
<template>
  <div class="implement-form-group-wrap">
    <fieldset>
      <legend>
        <span class="title-item">{{title}}</span>
        <el-button size="mini" type="text" @click="handleCopyGroup" v-show="hasCopy">复制</el-button>
        <el-button v-show="canRename" size="mini" type="text" @click="handleRenameGroup">重命名</el-button>
        <!-- <div v-show="isEdit" class="title-item copy-btn" @click="handleCopyCaliber">复制</div> -->
        <!-- <div v-show="canRename" class="title-item rename-btn" @click="handleRenameCaliber">重命名</div> -->
      </legend>
      <el-form>
        <el-row :gutter="20">
          <el-col :span="getSpan(item)" v-for="(item, index) in formatData" :key="index">
            <div class="form-field-wrap" v-if="item.value">
              <el-form-item
                :label="item.structName+'：'"
                v-if="showLogIcon(item)"
                :rules="[
                  { required: item.isMust === 1, message: item.structName + '不能为空', trigger: 'blur' }
                ]"
              >
                <!-- <div
                  class="data-log-icon-wrap"
                  v-if="isEdit && showLogIcon(item) && item.isCopy !== 1"
                >
                  <gov-field-log-popups
                    @revert="handleRevertField"
                    :household-id="householdId"
                    :struct-id="item.id"
                    :project-id="projectId"
                  ></gov-field-log-popups>
                </div>-->
                <!-- <gov-measure-tool
                  :disabled="!isEdit || item.isRead === 1"
                  :unit-name="item.unitName"
                  :unit-id="item.unitId"
                  :dot="item.dot"
                  v-model="item.value"
                  :label="item.structName"
                  v-if="item.structType === 'di'"
                ></gov-measure-tool>
                <el-input
                  size="small"
                  v-if="item.structType === 't'"
                  :disabled="!isEdit || item.isRead === 1"
                  placeholder="请输入"
                  v-model="item.value"
                ></el-input>
                <el-input
                  size="small"
                  v-if="item.structType === 'n'"
                  :disabled="!isEdit || item.isRead === 1"
                  v-model="item.value"
                  class="w100"
                  @change="checkDot(item.value, item.dot, index)"
                  onkeyup="value=value.replace(/[^\d^\.]+/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.')"
                >
                  <template slot="append" v-if="item.unitId">{{item.unitName}}</template>
                </el-input>
                <el-select
                  v-if="item.structType === 'm' || item.structType === 's'"
                  size="small"
                  :disabled="!isEdit || item.isRead === 1"
                  class="w100"
                  clearable
                  collapse-tags
                  :multiple="item.structType === 'm'"
                  v-model="item.value"
                >
                  <el-option
                    v-for="option in item.structItemList"
                    :key="option.id"
                    :label="option.value"
                    :value="option.value"
                  ></el-option>
                </el-select>
                <el-date-picker
                  v-if="item.structType ==='d'"
                  size="small"
                  v-model="item.value"
                  clearable
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="date"
                  :disabled="!isEdit || item.isRead === 1"
                  class="w100"
                  placeholder="选择日期"
                ></el-date-picker>
                <el-date-picker
                  v-if="item.structType ==='dt'"
                  size="small"
                  v-model="item.value"
                  clearable
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  :disabled="!isEdit || item.isRead === 1"
                  class="w100"
                  placeholder="选择时间"
                ></el-date-picker>
                <el-input
                  type="textarea"
                  size="small"
                  v-if="item.structType ==='ta'"
                  :rows="2"
                  placeholder="请输入内容"
                  :disabled="!isEdit || item.isRead === 1"
                  v-model="item.value"
                ></el-input>-->
                <!-- <div class="w100" style="line-height:24px;" v-if="item.structType === 'm'">
                  <span v-if="item.value.indexOf(',')===-1">{{item.value[0]}}</span>
                  <span style="margin-left:10px" v-if="item.value.length>0">+{{item.value.length-1}}</span>
                </div> -->
                <div class="w100" style="line-height:23px;" >{{item.value}}  {{item.unitName}}</div>
              </el-form-item>
              <template v-else>
                <div v-if="item.structType ==='k'">
                  <form-struct-caliber
                    :caliberData="item"
                    :project-id="projectId"
                    :household-id="householdId"
                    @copy="handleCopyCaliber"
                    @re-name="handleRenameCaliber"
                    @delete="handleDeleteCaliber"
                    @query-data="handleQueryData"
                    :isEdit="isEdit"
                  ></form-struct-caliber>
                </div>
              </template>
            </div>
          </el-col>
        </el-row>
        <!-- <el-row v-for="item in caliberStruct" :key="item.key">
          <form-struct-caliber
            :caliberData="item"
            @copy="handleCopyCaliber"
            @re-name="handleRenameCaliber"
            @delete="handleDeleteCaliber"
            :isEdit="isEdit"
          >
          </form-struct-caliber>
        </el-row>-->
      </el-form>
    </fieldset>
    <el-dialog
      title="复制"
      width="500px"
      custom-class="household-detail--form-dialog-wrap"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="showCopyForm"
      @close="handleCloseCopy"
    >
      <el-form ref="copygroup" size="small" :model="copyForm" :rules="rules">
        <el-row>
          <el-form-item label="分组名称" label-width="120px" prop="name">
            <el-input
              style="width: 217px;"
              v-model="copyForm.name"
              autocomplete="off"
              placeholder="请输入分组名称"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="复制类型" label-width="120px">
            <el-select v-model="copyForm.copyType" placeholder="复制类型">
              <el-option label="保留所有数据" :value="1"></el-option>
              <el-option label="不保留" :value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCloseCopy">取 消</el-button>
        <el-button size="small" type="primary" @click="handleSubmitCopy">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="重命名"
      custom-class="household-detail--form-dialog-wrap"
      width="500px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="showRename"
      :before-close="handleCancelRename"
    >
      <el-form :model="formRename" size="small" class="demo-ruleForm" ref="rename" :rules="grules">
        <el-form-item label="分组名称" label-width="120px" prop="name">
          <el-input v-model="formRename.name" autocomplete="off" placeholder="请输入分组名称"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCancelRename">取 消</el-button>
        <el-button size="small" type="primary" @click="handleSubmitRename">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FormStructCaliber from './form-struct.caliber.vue';
import GovMeasureTool from './measure-tool';
import { merge, deepCopyData, isUndef } from '@/untils';
// import GovFieldLogPopups from './struct-log-popups';
// import { mapActions } from 'vuex';
export default {
  props: {
    formStructId: {
      type: String
    },
    groupData: {
      type: Array,
      isRequired: true
    },
    isProject: {
      type: Boolean,
      default: false
    },
    title: [String],
    fieldId: {
      type: [String, Number],
      required: true
    },
    copySource: {
      type: String,
      required: true
    },
    isEdit: {
      type: Boolean,
      required: true
    },
    projectId: {
      type: String,
      required: true
    },
    householdId: {
      type: String
    }
  },
  components: {
    GovMeasureTool,
    FormStructCaliber
  },
  computed: {
    canRename() {
      return this.isEdit === true && this.copySource !== '-1';
    },
    // 格式化后的数据
    formatData() {
      if (this.groupData && Array.isArray(this.groupData)) {
        for (let item of this.groupData) {
          // 多选类型
          // if (item.structType === 'm') {
          //   // 多选框的值为 []
          //   const isArray = item.value instanceof Array;
          //   if (!isArray) {
          //     let value = item.value;
          //     item.value =
          //       value && typeof value === 'string' ? value.split(',') : [];
          //   }
          //   if (item.value.length <= 0) {
          //     item.value = '';
          //   }
          //   continue;
          // }
          // 测距仪类型
          if (item.structType === 'di') {
            if (isUndef(item.oldValue)) {
              item.oldValue = item.computationProcess || 'NOT';
              item.value = item.computationProcess;
            }
            // item.value = item.computationProcess;
            continue;
          }
          if (item.structType === 'k') {
            const { structCaliberDtoList } = item;
            if (item.caliberDataList !== null) {
              item.caliberDataList.forEach(data => {
                data.caliberTypeList = deepCopyData(structCaliberDtoList);
                if (data.caliberTypeId !== '') {
                  for (let caliberType of structCaliberDtoList) {
                    if (data.caliberTypeId === caliberType.caliberTypeId) {
                      data.caliberProList = caliberType.caliberItems;
                      break;
                    }
                  }
                }
                if (
                  data.caliberItemId !== '' &&
                  Array.isArray(data.caliberProList)
                ) {
                  for (let pro of data.caliberProList) {
                    if (data.caliberItemId === pro.id) {
                      data.caliberSpecificationList =
                        pro.caliberSpecificationDtos;
                      break;
                    }
                  }
                }
              });
            }
          }
        }
      }
      return this.groupData;
    },
    hasCopy() {
      return !this.isProject && this.isEdit;
    }
  },
  data() {
    return {
      copyForm: {
        name: '',
        copyType: 1
      },
      formRename: {
        name: ''
      },
      grules: {
        name: [{ required: true, message: '请输入新的分组名称' }]
      },
      rules: {
        name: [{ required: true, message: '请输入复制后的分组名称' }]
      },
      showCopyForm: false,
      showRename: false,
      localGroupData: []
    };
  },
  methods: {
    handleQueryData(data) {
      this.$emit('query-group-caliber-table-data', this.formStructId, data);
    },
    // 回退普通字段数据
    handleRevertField(row) {
      for (let item of this.groupData) {
        if (item.id === row.structId) {
          if (item.structType === 'di') {
            item.value = item.computationProcess = row.hisComputationProcess;
          } else {
            item.value = row.historyValue;
          }
          break;
        }
      }
    },
    // 获取el-col的宽度
    getSpan(item) {
      const blockType = ['b', 'g', 'k', 'ta'];
      const isBlock = blockType.indexOf(item.structType) > -1;
      if (isBlock) {
        return 24;
      }
      return 12;
    },
    // 是不显示 日志功能
    showLogIcon(item) {
      const blockType = ['b', 'g', 'k'];
      const isBlock = blockType.indexOf(item.structType) > -1;
      return !isBlock;
    },
    handleCopyGroup() {
      this.showCopyForm = true;
    },
    handleSubmitCopy() {
      this.$refs.copygroup.validate(valid => {
        if (valid) {
          const form = merge({}, this.copyForm);
          const copySource =
            this.copySource === '-1' ? this.fieldId : this.copySource;
          const data = {
            copySourceId: copySource,
            copyStructName: form.name,
            id: this.fieldId,
            copyType: form.copyType
          };
          this.$emit('copy', data, () => {
            this.showCopyForm = false;
          });
        }
      });
    },
    handleCloseCopy() {
      this.$refs.copygroup.resetFields();
      this.showCopyForm = false;
      // ssss
    },
    // 复制口径项详情数据
    copyCaliberProject(caliberDataList, copyType = 1) {
      // 1: 保留口径项及数据 2: 仅保留口径项 3: 不保留
      let calibers = [];
      let key = 1;
      if (Array.isArray(caliberDataList) && copyType !== 3) {
        calibers = caliberDataList.map(caliberProject => {
          caliberProject.isEdit = true;
          const model = {
            caliberItemId: '', // 项目
            isEdit: true,
            caliberTypeList: [], // 口径类型
            caliberProList: [], // 口径项目数据
            caliberSpecificationList: [], // 口径规格
            caliberSpecificationId: '', // 规格
            caliberTypeId: '', // 口径类别
            changedPrice: 0, // 单价
            newnessRate: 100, // 成亲率
            process: '', // 过程
            remark: '', // 备注
            totalAmount: 0, // 总价
            workAmount: 0 // 工程量
          };
          if (copyType === 1) {
            for (let key of Object.keys(model)) {
              model[key] = caliberProject[key];
            }
            model.key = ++key;
            return model;
          } else {
            model.caliberItemId = caliberProject.caliberItemId;
            model.caliberSpecificationId =
              caliberProject.caliberSpecificationId;
            model.caliberTypeId = caliberProject.caliberTypeId;
            model.key = ++key;
            return model;
          }
        });
      } else {
        return [
          {
            caliberItemId: '', // 项目
            isEdit: true,
            key: ++key,
            caliberTypeList: [], // 口径类型
            caliberProList: [], // 口径项目数据
            caliberSpecificationList: [], // 口径规格
            caliberSpecificationId: '', // 规格
            caliberTypeId: '', // 口径类别
            changedPrice: 0, // 单价
            newnessRate: 100, // 成亲率
            process: '', // 过程
            remark: '', // 备注
            totalAmount: 0, // 总价
            workAmount: 0 // 工程量
          }
        ];
      }
      return calibers;
    },
    // 复制分组内的口径
    handleCopyCaliber(params, callback) {
      const timespan = new Date().getTime();
      let source = {
        structType: 'k',
        isCopy: 1,
        copyType: params.copyType,
        copySource: params.copySource,
        id: timespan,
        newStructName: params.copyStructName,
        structName: params.copyStructName,
        structCaliberDtoList: [],
        caliberDataList: []
      };
      const isDuplicate = this.groupData.some(
        item => item.structName === params.copyStructName
      );
      if (isDuplicate) {
        this.$message({
          message: '口径表格名称重复！',
          type: 'warning'
        });
        return false;
      }
      for (let item of this.groupData) {
        if (item.structType === 'k' && item.id === params.caliberDataId) {
          source.structCaliberDtoList = deepCopyData(item.structCaliberDtoList);
          // structCaliberDtoList
          source.caliberDataList = this.copyCaliberProject(
            item.caliberDataList,
            params.copyType
          );
          // source = item;
          break;
        }
      }
      const data = {
        id: this.fieldId,
        data: source
      };
      this.$emit('copy-inner-caliber', data, callback);
    },
    // 重命名复制 的分组
    handleRenameGroup() {
      this.showRename = true;
    },
    // 重命名取消
    handleCancelRename() {
      this.showRename = false;
      this.formRename.name = '';
    },
    handleSubmitRename() {
      this.$refs.rename.validate(valid => {
        if (valid) {
          this.$emit(
            're-name',
            {
              name: this.formRename.name,
              id: this.fieldId
            },
            () => {
              this.handleCancelRename();
            }
          );
        } else {
          return false;
        }
      });
    },
    handleRenameCaliber(rdata, callback) {
      const data = {
        id: this.fieldId,
        data: rdata
      };
      const { name } = rdata;
      const isDuplicate = this.groupData.some(item => item.structName === name);
      if (isDuplicate) {
        this.$message({
          message: '口径表格名称重复！',
          type: 'warning'
        });
        return false;
      }
      this.$emit('rename-inner-caliber', data, callback);
    },
    // 删除复制的分组
    handleDeleteCopyItem(id) {
      this.$emit('delete', this.fieldId);
    },
    handleDeleteCaliber(cid) {
      const data = {
        id: this.fieldId,
        cid
      };
      this.$emit('delete-inner-caliber', data);
    },
    checkDot(value, dot, index) {
      if (dot !== null && dot >= 0) {
        if (isNaN(value)) {
          this.$message.warning('当前限制只能输入数字');
        }
        // if (Number(value) === 0) {
        //   this.formatData[index].value = '';
        // }
        if (value.indexOf('.') !== -1) {
          if (value.toString().split('.')[1].length > dot) {
            this.$message.warning(`当前限制小数点后${dot}位`);
            if (dot === 0) {
              this.formatData[index].value = value.substring(
                0,
                value.indexOf('.')
              );
            } else {
              this.formatData[index].value = value.substring(
                0,
                value.indexOf('.') + dot + 1
              );
            }
          }
        }
      }
    }
  }
};
</script>

<style>
.implement-form-group-wrap {
}
.title-item {
  margin-right: 15px;
}
legend {
  padding: 0 10px;
  margin-left: 20px;
}
.w30 {
  width: 30%;
  display: inline-block;
  margin-right: 16px;
}

.w100 {
  width: 100% !important;
}
fieldset {
  border: 1px solid #e3e3e3;
  min-width: 100px;
  padding: 10px;
}
.household-detail--form-dialog-wrap .el-form-item {
  margin-bottom: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/form-struct.group.vue